import {IAction} from "../IAction";
import {cloneDeep} from "lodash";
import InitialAcquisitionStore, {IAcquisitionStore} from "./InitialAcquisitionStore";
import {AcquisitionClickParam} from "@devour/client";

export enum AcquisitionAction {
    NEW_ACQUISITION_SIGNALS = "NEW_ACQUISITION_SIGNALS",
    REMOVE_ACQUISITION_SIGNALS = "REMOVE_ACQUISITION_SIGNALS",
}

export interface IAcquisitionSignals {
    utmSource?: string;
    utmMedium?: string;
    utmCampaign?: string;
    referrer?: string;
    landingPage?: string;
    clickParam?: AcquisitionClickParam;
    clickValue?: string;
}

export default function acquisitionReducer(store: IAcquisitionStore = InitialAcquisitionStore, a: IAction<AcquisitionAction, any>): IAcquisitionStore {

    const n: IAcquisitionStore = cloneDeep(store);
    const oneMonth = Date.now() + 30 * 24 * 60 * 60 * 1000;

    switch (a.type) {
        case AcquisitionAction.NEW_ACQUISITION_SIGNALS:
            /*
             * Written whole, never merged. A later tagged arrival is a new
             * touch, and keeping the previous campaign's medium alongside this
             * one's source would attribute a signup to a pairing that never
             * happened.
             */
            n.utmSource = a.payload.utmSource;
            n.utmMedium = a.payload.utmMedium;
            n.utmCampaign = a.payload.utmCampaign;
            n.referrer = a.payload.referrer;
            n.landingPage = a.payload.landingPage;
            /*
             * Written whole with the rest, which matters more here than anywhere else in this
             * block: a click id belongs to ONE arrival. Carrying a previous `gclid` forward onto a
             * later touch would report a conversion against a click that did not produce it — and
             * that report goes to the ad platform, which then optimises on it.
             */
            n.clickParam = a.payload.clickParam;
            n.clickValue = a.payload.clickValue;
            n.acquisitionExpiry = oneMonth;
            break;
        case AcquisitionAction.REMOVE_ACQUISITION_SIGNALS:
            n.utmSource = undefined;
            n.utmMedium = undefined;
            n.utmCampaign = undefined;
            n.referrer = undefined;
            n.landingPage = undefined;
            n.clickParam = undefined;
            n.clickValue = undefined;
            n.acquisitionExpiry = undefined;
            break;
        default:
            break;
    }

    return n;
}
